(function () {
  'use strict';

  if (window.__biloniyaCartUpsellInstalled) return;
  window.__biloniyaCartUpsellInstalled = true;

  var STYLE_ID = 'biloniya-cart-upsell-styles';
  var BANNER_ID = 'biloniya-cart-upsell-banner';

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      #${BANNER_ID} {
        box-sizing: border-box;
        width: 100%;
        margin: 0 0 12px;
        padding: 12px;
        border: 1px solid #e4c5ce;
        border-radius: 13px;
        background: linear-gradient(140deg, #fffaf5 0%, #fff0f4 58%, #f8e8dc 100%);
        color: #59263a;
        font-family: inherit;
        box-shadow: 0 4px 14px rgba(93, 35, 55, .08);
        animation: biloniyaCartUpsellIn .35s ease both;
      }

      #${BANNER_ID} *,
      #${BANNER_ID} *::before,
      #${BANNER_ID} *::after { box-sizing: border-box; }

      #${BANNER_ID} .bcu-header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin: -12px -12px 11px;
        padding: 10px 12px;
        border-radius: 12px 12px 0 0;
        background: linear-gradient(105deg, #70243f, #98415f, #70243f);
        background-size: 200% 100%;
        color: #fff9f2;
        animation: biloniyaCartHeaderGlow 7s ease-in-out infinite;
      }

      #${BANNER_ID} .bcu-gift {
        display: grid;
        place-items: center;
        flex: 0 0 32px;
        width: 32px;
        height: 32px;
        border: 1px solid rgba(255,255,255,.35);
        border-radius: 9px;
        background: rgba(255,255,255,.12);
        font-size: 19px;
        animation: biloniyaCartGiftFloat 2.5s ease-in-out infinite;
      }

      #${BANNER_ID} .bcu-title {
        flex: 1;
        font-size: 11px;
        font-weight: 800;
        letter-spacing: .6px;
        line-height: 1.4;
      }

      #${BANNER_ID} .bcu-sparkle {
        color: #f5d7a1;
        font-size: 22px;
        animation: biloniyaCartSparkle 2s ease-in-out infinite;
      }

      #${BANNER_ID} .bcu-subtitle {
        margin: 0 0 10px;
        color: #805a67;
        font-size: 11px;
        line-height: 1.5;
        text-align: center;
      }

      #${BANNER_ID} .bcu-deals {
        display: grid;
        grid-template-columns: minmax(0, 1fr);
        gap: 7px;
      }

      #${BANNER_ID} .bcu-deal {
        display: flex;
        align-items: center;
        gap: 8px;
        min-width: 0;
        padding: 9px 8px;
        border: 1px solid #ead4d9;
        border-radius: 9px;
        background: rgba(255,255,255,.88);
      }

      #${BANNER_ID} .bcu-deal.featured {
        border-color: #c9a16e;
        background: linear-gradient(110deg, #fff8e9, #fff0e0);
      }

      #${BANNER_ID} .bcu-icon {
        display: grid;
        place-items: center;
        flex: 0 0 30px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: #f8e3e9;
        color: #923b59;
        font-size: 19px;
      }

      #${BANNER_ID} .bcu-copy {
        display: flex;
        flex: 1;
        flex-direction: column;
        gap: 3px;
        min-width: 0;
      }

      #${BANNER_ID} .bcu-copy strong {
        color: #662840;
        font-size: 10px;
        font-weight: 800;
        letter-spacing: .25px;
        line-height: 1.4;
      }

      #${BANNER_ID} .bcu-copy small {
        color: #866771;
        font-size: 9px;
        line-height: 1.35;
      }

      #${BANNER_ID} .bcu-price {
        flex-shrink: 0;
        color: #762b48;
        font-size: 16px;
        font-weight: 850;
        white-space: nowrap;
      }

      #${BANNER_ID} .bcu-cta {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        width: 100%;
        margin-top: 10px;
        padding: 10px 12px;
        border: 1px solid #762b48;
        border-radius: 8px;
        background: linear-gradient(105deg, #762b48, #98435e);
        color: #fff9f4;
        font-size: 10px;
        font-weight: 800;
        letter-spacing: .7px;
        text-align: center;
        text-decoration: none;
        transition: filter .2s ease, transform .2s ease;
      }

      #${BANNER_ID} .bcu-cta:hover {
        color: #fff;
        filter: brightness(1.08);
        transform: translateY(-1px);
      }

      #${BANNER_ID} .bcu-note {
        margin: 7px 0 0;
        color: #987983;
        font-size: 9px;
        line-height: 1.4;
      }

      @keyframes biloniyaCartUpsellIn {
        from { opacity: 0; transform: translateY(6px); }
        to { opacity: 1; transform: translateY(0); }
      }

      @keyframes biloniyaCartHeaderGlow {
        0%, 100% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
      }

      @keyframes biloniyaCartGiftFloat {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-2px); }
      }

      @keyframes biloniyaCartSparkle {
        0%, 100% { opacity: .7; transform: scale(.92); }
        50% { opacity: 1; transform: scale(1.12); }
      }

      @media (min-width: 750px) {
        #${BANNER_ID} .bcu-deals {
          grid-template-columns: repeat(2, minmax(0, 1fr));
        }
        #${BANNER_ID} .bcu-deal { gap: 6px; padding: 8px 6px; }
        #${BANNER_ID} .bcu-copy strong { font-size: 9px; }
        #${BANNER_ID} .bcu-price { font-size: 14px; }
      }

      @media (prefers-reduced-motion: reduce) {
        #${BANNER_ID}, #${BANNER_ID} *,
        #${BANNER_ID} *::before, #${BANNER_ID} *::after {
          animation: none !important;
          transition: none !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function makeBanner() {
    var banner = document.createElement('div');
    banner.id = BANNER_ID;
    banner.setAttribute('role', 'complementary');
    banner.setAttribute('aria-label', 'Kurti bundle offers');

    banner.innerHTML = `
      <div class="bcu-header">
        <span class="bcu-gift" aria-hidden="true">🎁</span>
        <span class="bcu-title">EXCLUSIVE KURTI OFFERS</span>
        <span class="bcu-sparkle" aria-hidden="true">✦</span>
      </div>
      <p class="bcu-subtitle">Mix your favourite designs and save more!</p>
      <div class="bcu-deals">
        <div class="bcu-deal">
          <span class="bcu-icon" aria-hidden="true">✿</span>
          <span class="bcu-copy">
            <strong>ANY 2 KURTIS</strong>
            <small>Mix designs &amp; sizes</small>
          </span>
          <strong class="bcu-price">₹999</strong>
        </div>
        <div class="bcu-deal featured">
          <span class="bcu-icon" aria-hidden="true">✧</span>
          <span class="bcu-copy">
            <strong>ANY 3 KURTIS</strong>
            <small>More styles, more savings</small>
          </span>
          <strong class="bcu-price">₹1,399</strong>
        </div>
      </div>
      <a class="bcu-cta" href="/collections/suits">
        EXPLORE KURTIS <span aria-hidden="true">→</span>
      </a>
      <p class="bcu-note">Bundle prices require the matching discount or bundle pricing setup.</p>
    `;
    return banner;
  }

  function injectBanner() {
    addStyles();

    // Horizon's cart drawer uses this summary container when the cart has items.
    var summary = document.querySelector('#cart-drawer .cart-drawer__summary');
    if (!summary) return;

    // Insert only once; mutation observer re-adds it if Horizon re-renders the drawer.
    if (summary.querySelector('#' + BANNER_ID)) return;

    summary.insertBefore(makeBanner(), summary.firstChild);
  }

  function start() {
    injectBanner();

    var observer = new MutationObserver(function () {
      injectBanner();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Some themes replace summary contents without changing their parent.
    document.addEventListener('click', function (event) {
      if (event.target.closest('a[href*="/cart"], button[aria-controls*="cart"], [aria-label*="cart" i]')) {
        window.setTimeout(injectBanner, 120);
        window.setTimeout(injectBanner, 500);
      }
    });

    document.addEventListener('submit', function () {
      window.setTimeout(injectBanner, 250);
      window.setTimeout(injectBanner, 800);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();